import { Box, Button, Typography } from '@mui/material';
import React from 'react';

import Modal from '@/components/Modal';
import { t } from '@/services/translations/config';
import { COLOR, ENTITY_COLOR } from '@/theme/colors';

import { Props } from './types';

const SuccessInvitationSentModal: React.FC<Props> = ({ handleClose }) => {
    return (
        <Modal isOpen center styles="pt-11 pb-7 px-9 min-w-[760px]">
            <Box className="flex flex-col">
                <Typography
                    fontSize={16}
                    fontWeight={700}
                    color={COLOR.ebonyClay}
                    className="mb-4"
                >
                    {t('TeamInvitationModal:successInvitationModal:title')}
                </Typography>
                <Typography
                    fontSize={14}
                    fontWeight={300}
                    color={COLOR.ebonyClay}
                >
                    {t(
                        'TeamInvitationModal:successInvitationModal:paragraph_1',
                    )}
                </Typography>
                <Typography
                    fontSize={14}
                    fontWeight={300}
                    color={COLOR.ebonyClay}
                >
                    {t(
                        'TeamInvitationModal:successInvitationModal:paragraph_2',
                    )}
                </Typography>

                <Button
                    className="px-8 py-2.5 self-end"
                    variant="contained"
                    sx={{
                        backgroundColor: ENTITY_COLOR.teams,
                        '&:hover': {
                            backgroundColor: ENTITY_COLOR.teams,
                        },
                    }}
                    onClick={handleClose}
                >
                    <Typography
                        sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            color: COLOR.white,
                        }}
                    >
                        {t('Actions:done')}
                    </Typography>
                </Button>
            </Box>
        </Modal>
    );
};

export default SuccessInvitationSentModal;
